import { Modal, Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import UploadImage from "../assets/icones/upload_image.svg";
import Photos from "@newProduct/components/Photos";
import { Col, Row } from "react-bootstrap";
import { apiSend, getRoute } from "@services/axios";

const ImageUploadModal = ({ open, onClose, productId, onPhotosSaved }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPhotos, setShowPhotos] = useState(false);

  const handleUploadImages = () => setShowPhotos(true);

  const handleViewProduct = async () => {
    localStorage.removeItem("product");
    window.loader(1);

    const response = await apiSend(
      [
        getRoute("PRODUCT_RETRIEVE"),
        localStorage.getItem("product_id_save"),
      ].join("/"),
      "get"
    );
    const item = response?.data?.result;
    window.loader(0);
    onClose();
    navigate(
      `/products/${item.id}/${item.countryName}/${item.service}/${item.name}`
    );
  };

  const handleSkip = () => {
    localStorage.removeItem("product");
    onClose();
    navigate("/dashboard");
  };

  const handleBack = () => setShowPhotos(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="md"
      keyboard={false}
      backdrop="static"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="text-center p-3 position-relative"
      >
        {!showPhotos ? (
          <>
            <h4 className="mb-3 fw-bold text-dark">
              {t("product_submitted_successfully")}
            </h4>
            <div className="mb-4">
              <img
                src={UploadImage}
                alt="Upload Product Images"
                className="mx-auto mb-3"
                style={{ width: "auto", height: "200px" }}
              />
            </div>
            <p className="mb-4 text-muted">{t("suggest_upload_images")}</p>
            <Row>
              <Col md="4">
                <Button
                  appearance="primary"
                  block
                  onClick={handleUploadImages}
                  className="btn-lg fw-semibold py-3 rounded-5"
                  style={{
                    backgroundColor: "#8077EC",
                    borderColor: "#8077EC",
                  }}
                >
                  {t("upload_images_now")}
                </Button>
              </Col>
              <Col md="4">
                <Button
                  appearance="ghost"
                  block
                  onClick={handleViewProduct}
                  className="btn-lg fw-semibold py-3 rounded-5"
                >
                  {t("view_product")}
                </Button>
              </Col>
              <Col md="4">
                <Button
                  appearance="default"
                  block
                  onClick={handleSkip}
                  className="btn-lg fw-semibold py-3 rounded-5"
                  style={{
                    backgroundColor: "#FFDB80",
                    borderColor: "#FFDB80",
                    color: "#8077EC",
                  }}
                >
                  {t("skip_and_go_home")}
                </Button>
              </Col>
            </Row>
          </>
        ) : (
          <div>
            {/* Back icon */}
            <div
              onClick={handleBack}
              style={{
                position: "absolute",
                top: "15px",
                left: "15px",
                cursor: "pointer",
              }}
            >
              <ArrowLeft size={24} strokeWidth={2} color="#333" />
            </div>

            <Photos
              productId={productId}
              onSave={() => {
                setShowPhotos(false);
                if (onPhotosSaved) onPhotosSaved();
                onClose();
              }}
            />
          </div>
        )}
      </motion.div>
    </Modal>
  );
};

export default ImageUploadModal;
